import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setErrorDispatcher } from '../../../hooks/setErrorDispatcher';
import Modal from '../../shared/Modal/Modal';
import ErrorHandler from '../../shared/Modal/ModalContent/ErrorHandler/ErrorHandler';
import { getTranslation } from '../../../utils/translation';

class ErrorBoundary extends Component {
    state = {
        error: '',
        errorInfo: '',
        hasError: false,
    };

    componentDidCatch(error, errorInfo) {
        console.error(errorInfo);
        this.setState({ errorInfo, hasError: true });
        setErrorDispatcher(
            true,
            getTranslation('generalErrorModalDescription'),
            getTranslation('generalErrorModalTitle'),
            false
        );
    }

    render() {
        const { hasError } = this.state;
        const { isErrorModalVisible } = this.props;

        return (
            <>
                {hasError ? null : this.props.children}
                {isErrorModalVisible && (
                    <Modal isVisible={isErrorModalVisible} width='476px'>
                        <ErrorHandler />
                    </Modal>
                )}
            </>
        );
    }
}

const mapStateToProps = state => ({
    isErrorModalVisible: state.auth.isErrorHandlerActive,
});

export default connect(mapStateToProps, null)(ErrorBoundary);
